import { useTranslation, Trans } from "react-i18next";

function MaskLicenseAlert() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center fixed justify-center top-0 left-0 w-full h-full bg-[#FFFFFF] bg-opacity-75 z-20 pointer-events-auto">
      <div className="bg-[#00A7A6] text-white p-4 rounded-xl">
        <div className="flex flex-col">
          <span className="text-xl font-semibold">
            {t("maskLicenseAlert.title")}
          </span>
          <span>{t("maskLicenseAlert.subscriptionExpired")}</span>
        </div>
        <div className="mt-3">
          <h6>{t("maskLicenseAlert.renewalPrompt")}</h6>
          <ul className="list-disc ml-5">
            <li>
              <Trans i18nKey="maskLicenseAlert.features.realTimeTracking" />
            </li>
            <li>
              <Trans i18nKey="maskLicenseAlert.features.errorDetection" />
            </li>
            <li>
              <Trans i18nKey="maskLicenseAlert.features.routeOptimization" />
            </li>
            <li>
              <Trans i18nKey="maskLicenseAlert.features.regulatoryReports" />
            </li>
          </ul>
        </div>
        <div>
          <span className="underline underline-offset-4 text-white font-medium">
            <Trans i18nKey="maskLicenseAlert.contact" />
          </span>
        </div>
      </div>
    </div>
  );
}

export default MaskLicenseAlert;
